import { Reveal, RevealGroup, RevealItem } from "@/lib/motion";
import { Infinity as InfinityIcon, Lock, ShieldCheck } from "lucide-react";

const HIGHLIGHTS = [
  { icon: InfinityIcon, title: "No Inflation" },
  { icon: Lock, title: "No Future Minting" },
  { icon: ShieldCheck, title: "Predictable Supply" },
];

export default function FixedSupplySection() {
  return (
    <section id="fixed-supply" className="relative overflow-hidden py-28 sm:py-36">
      <div className="absolute inset-0 -z-10 dot-bg opacity-40" />
      <div className="absolute left-1/2 top-1/2 -z-10 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-indigo-700/10 blur-[150px]" />

      <div className="mx-auto w-full max-w-7xl px-5 text-center sm:px-8">
        <Reveal className="mx-auto flex max-w-4xl flex-col items-center">
          <div className="inline-flex items-center gap-3">
            <span className="h-px w-8 bg-indigo-500/60" />
            <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-indigo-300">
              Fixed Supply
            </span>
            <span className="h-px w-8 bg-indigo-500/60" />
          </div>

          <h2 className="mt-8 font-display text-[9vw] font-black uppercase leading-none tracking-tighter text-gradient-indigo sm:text-6xl lg:text-7xl">
            50,000,000,000,000
          </h2>
          <div className="mt-2 font-mono text-sm uppercase tracking-[0.4em] text-gray-500">XVPR</div>

          <p className="mt-8 font-display text-xl font-bold uppercase tracking-tight text-white sm:text-2xl">
            50 Trillion. Fixed by Design.
          </p>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-gray-400 sm:text-lg">
            The total supply of XVPR is designed to remain permanently fixed. Once deployed, no
            additional XVPR can be created.
          </p>
        </Reveal>

        <RevealGroup className="mx-auto mt-14 grid max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
          {HIGHLIGHTS.map((h) => (
            <RevealItem key={h.title} data-testid={`fixed-supply-${h.title}`}>
              <div className="flex h-full flex-col items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.03] p-6 backdrop-blur-xl">
                <h.icon className="h-6 w-6 text-indigo-400" />
                <span className="font-display text-sm font-bold uppercase tracking-tight text-white">
                  {h.title}
                </span>
              </div>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
